import { connect } from 'react-redux';
import { RootState, Dispatch } from 'shared/state';
import {
  fetchSearchResults,
  selectCurrentPage,
} from 'shared/state/ducks/sites';
import SearchResults from './SearchResults';

interface SearchWidgetContainerProps {
  site: Site;
  currentPage: any;
  searchWidgetState: any;
  pageId: number;
}
const mapStateToProps = (
  state: RootState,
  ownProps: SearchWidgetContainerProps
) => ({
  searchResults: state.searchResults,
  currentPage: selectCurrentPage(ownProps.site.siteId, ownProps.pageId)(state),
  searchWidgetState: ownProps.searchWidgetState,
});

const mapDispatchToProps = (
  dispatch: Dispatch,
  ownProps: SearchWidgetContainerProps
) => ({
  fetchSearchResults: (query: string) =>
    dispatch(fetchSearchResults(query, ownProps.site)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchResults);
